__turbopack_context__.v({
  "attribution": "artwork-basics-module-scss-module___Kw-pG__attribution",
  "content": "artwork-basics-module-scss-module___Kw-pG__content",
  "imageWrapper": "artwork-basics-module-scss-module___Kw-pG__imageWrapper",
  "imageWrapperNoImage": "artwork-basics-module-scss-module___Kw-pG__imageWrapperNoImage",
  "materials": "artwork-basics-module-scss-module___Kw-pG__materials",
  "noImageContainer": "artwork-basics-module-scss-module___Kw-pG__noImageContainer",
  "noImageSvg": "artwork-basics-module-scss-module___Kw-pG__noImageSvg",
  "statement": "artwork-basics-module-scss-module___Kw-pG__statement",
  "statementHeader": "artwork-basics-module-scss-module___Kw-pG__statementHeader",
  "text": "artwork-basics-module-scss-module___Kw-pG__text",
  "thumbnail": "artwork-basics-module-scss-module___Kw-pG__thumbnail",
  "thumbnails": "artwork-basics-module-scss-module___Kw-pG__thumbnails",
  "title": "artwork-basics-module-scss-module___Kw-pG__title",
});
